/**
 * @Action: 路由白名单
 * @Author: Maple
 * @UpDate: 2026/1/21
 */

export default ['/', '/login', '/largeScreen/stationsMultiple','/invalidToken', '/uiChange/permission']
